/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const project = feature.project;
    const generalFeature = project.getFeature('general');

    const blocks: CodeBlock[] = [];

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
    ' Set the timezone to ${generalFeature.getSettingValueOptionName('TIMEZONE')}
    APP_TIMEZONE=${generalFeature.getSettingValue('TIMEZONE')}
    datetime_tz_offset=APP_TIMEZONE
    APP_LATITUDE=${generalFeature.getSettingValue('LATITUDE')}
    datetime_lat=APP_LATITUDE
    APP_LONGITUDE=${generalFeature.getSettingValue('LONGITUDE')}
    datetime_lng=APP_LONGITUDE`,
    });

    return blocks;
};
